module.exports = __webpack_public_path__ + "static/img/shili1.181bd72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shili1.jpg
// module id = EIqV
// module chunks = 1